import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {push} from 'connected-react-router'
import styled from 'styled-components'
// Components
import { Layout, PrimaryButton } from '../components'
// Mui
import Button from '@material-ui/core/Button'
import { TextField } from '@material-ui/core'
// Reducks
import { updateProfile } from '../reducks/users/operations'
import { getUserId } from '../reducks/users/selectors'
import { db } from '../firebase'

const ProfileEdit = () => {

    const dispatch = useDispatch()

    const selector = useSelector(state=>state)
    const userId = getUserId(selector)

    const [lastname, setLastname] = useState('')
    const [firstname, setFirstname] = useState('')
    const [postalCode, setPostalCode] = useState('')
    const [prefecture, setPrefecture] = useState('')
    const [city, setCity] = useState('')
    const [street, setStreet] = useState('')
    const [tel, setTel] = useState('')

    const complementAddress = () => {
        const { AjaxZip3 } = window
        AjaxZip3.zip2addr( 'postCode', '', 'address1', 'address2', 'address3' )
    }
    const onBlurZipcode = () => {
        setPrefecture(document.getElementById('address1').value)
        setCity(document.getElementById('address2').value)
        setStreet(document.getElementById('address3').value)
    }

    useEffect(()=>{
        if(userId){
            db.collection('users').doc(userId).get()
              .then(doc => {
                    const data = doc.data()
                    setLastname(data.lastname)
                    setFirstname(data.firstname)
                    setPostalCode(data.postalCode)
                    setPrefecture(data.prefecture)
                    setCity(data.city)
                    setStreet(data.street)
                    setTel(data.tel)
              })
        }
    },[userId])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>プロフィール編集</h1>
            <div className='spacer-50' />

            <Wrapper>
                <TextField 
                    label={'姓'} fullWidth={false} multiline={false} rows={1} required={true} type={'text'}
                    value={lastname} onChange={e=>setLastname(e.target.value)} variant='filled'
                    style={{width: '220px', marginRight: '40px', marginBottom: '10px'}}
                />
                <TextField 
                    label={'名'} fullWidth={false} multiline={false} rows={1} required={true} type={'text'}
                    value={firstname} onChange={e=>setFirstname(e.target.value)} variant='filled' style={{width: '220px'}}
                />
                <TextField 
                    label={'郵便番号'} fullWidth={false} multiline={false} rows={1} required={false} type={'text'}
                    value={postalCode} name="postCode" variant='filled'
                    onChange={e=>setPostalCode(e.target.value)} style={{width: '220px', marginBottom: '10px'}}
                    onKeyUp={complementAddress} onBlur={onBlurZipcode}
                /><br/>
                <TextField 
                    label={'都道府県'} fullWidth={false} multiline={false} rows={1} required={false} type={'text'}
                    name="address1" id="address1" variant='filled' 
                    value={prefecture} onChange={e=>setPrefecture(e.target.value)}
                    style={{width: '220px', marginRight: '40px', marginBottom: '10px'}}
                />
                {/* <SelectBox 
                    label={'都道府県'} required={false} options={prefectures.list}
                    name="address1" id="address1"
                    value={prefecture} onChange={e=>setPrefecture(e.target.value)}
                /> */}
                <TextField 
                    label={'市区町村'} fullWidth={false} multiline={false} rows={1} required={false} type={'text'}
                    name="address2" id="address2" variant='filled' style={{width: '220px', marginBottom: '10px'}}
                    value={city} onChange={e=>setCity(e.target.value)}
                />
                <TextField 
                    label={'番地以降'} fullWidth={true} multiline={false} rows={1} required={false} type={'text'}
                    name="address3" id="address3" variant='filled' style={{marginBottom: '10px'}}
                    value={street} onChange={e=>setStreet(e.target.value)}
                />
                <TextField 
                    label={'電話番号'} fullWidth={false} multiline={false} rows={1} required={false} type={'tel'} 
                    value={tel} onChange={e=>setTel(e.target.value)} variant='filled'
                    style={{width: '220px'}}
                />
            </Wrapper>


            <div className='spacer-50' />
            
            <div style={{textAlign: 'center'}}>
                <PrimaryButton label='保存する' operation={()=>dispatch(updateProfile(lastname,firstname,postalCode,prefecture,city,street,tel))} />
                <div className='spacer-25' />
                <Button onClick={()=>dispatch(push('/profile'))}>キャンセル</Button>
            </div>

            <div className='spacer-100' />
        </Layout>
    )
}

export default ProfileEdit

const Wrapper = styled.div`
    width: 480px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`